import { render } from "./SubmitButton.vue?vue&type=template&id=0aa236cc&scoped=true"
import script from "./SubmitButton.vue?vue&type=script&lang=js"
export * from "./SubmitButton.vue?vue&type=script&lang=js"

import "./SubmitButton.vue?vue&type=style&index=0&id=0aa236cc&lang=scss&scoped=true"
import "./SubmitButton.vue?vue&type=style&index=1&id=0aa236cc&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa236cc"]])

export default __exports__